<div class="col-12" *ngIf="loading">
  <br /><br />
  <div class="align-items-center d-flex justify-content-center" *ngIf="loading">
    <app-calibrant-load [small]="true"></app-calibrant-load>
  </div>
  <br /><br />
</div>

<div class="mat-elevation-z8" matSort *ngIf="program && !loading">
  <table *ngIf="dataSource" mat-table multiTemplateDataRows [dataSource]="dataSource" style="width: 100%;">
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Status</th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="getSiteDispatchStats(element)"  matTooltip="{{getStatusTooltipText(element)}}" matTooltipClass="status-tooltip">
          <mat-icon  [ngStyle]="{ color: getSiteStatusColor(element)}">circle</mat-icon>
        </span>
        <span *ngIf="!getSiteDispatchStats(element)">
          N/A
        </span>
      </td>
   </ng-container>
    <ng-container matColumnDef="site">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Name</th>
      <td mat-cell *matCellDef="let element">
        {{element.name}}<br />
        <span class="site-status">
          <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['NOT_AUTOMATIC_OPTIMIZATION'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
          {{aggregatedStoreStatus(element)}}
        </span><br />
        <span class="site-status">
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['BAD_SITE_STATE', 'BAD_DER_STATE'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
        {{getSiteStatus(element)}}
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="requestedPower">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Requested Power</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['ACTUAL_POWER_CRITICAL'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['ACTUAL_POWER_UNDERPERFORMING'])" [ngStyle]="{ color: '#FECC32'}">report_problem</mat-icon>
        {{getSiteStat(element, 'requestedPower')}}
      </td>
    </ng-container>
    <ng-container matColumnDef="plannedOutput">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Planned Power</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['CHARGING_NOT_GENERATING'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['PLANNED_POWER_CRITICAL'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['PLANNED_POWER_UNDERPERFORMING'])" [ngStyle]="{ color: '#FECC32'}">report_problem</mat-icon>
        {{getSiteStat(element, 'plannedPower')}}
        <br />
      </td>
    </ng-container>
    <ng-container matColumnDef="maxPower">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Max Power</th>
      <td mat-cell *matCellDef="let element">
        {{getSiteStat(element, 'maxDispatchPower')}}
      </td>
    </ng-container>
    <ng-container matColumnDef="currentPower">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Current Power</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['ACTUAL_POWER_CRITICAL'])" [ngStyle]="{ color: '#FC4B88'}">report_problem</mat-icon>
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['ACTUAL_POWER_UNDERPERFORMING'])" [ngStyle]="{ color: '#FECC32'}">report_problem</mat-icon>
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['INADEQUATE_ENERGY_FOR_MANEUVER_DURATION'])" [ngStyle]="{ color: '#FECC32'}">report_problem</mat-icon>
        {{ getSiteStat(element, 'currentPower')}}
      </td>
    </ng-container>
    <ng-container matColumnDef="stateOfCharge">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>State of Charge</th>
      <td mat-cell *matCellDef="let element">
        <mat-icon *ngIf="getSiteStatusDetailAlert(element, ['INADEQUATE_ENERGY_FOR_MANEUVER_DURATION'])" [ngStyle]="{ color: '#FECC32'}">report_problem</mat-icon>
        {{getSiteStat(element, 'stateOfCharge')}}
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[5, 10, 20, 50]"
                 showFirstLastButtons
                 [pageIndex]="0"
                 [pageSize]="10"
                 aria-label="Select from site list.">
  </mat-paginator>
</div>
